const PREFIX = 'Admin/';
export const ADMINS_REQUESTED = `${PREFIX}ADMINS_REQUESTED`;
export const ADMINS_SUCCEEDED = `${PREFIX}ADMINS_SUCCEEDED`;
export const ADMINS_FAILED = `${PREFIX}ADMINS_FAILED`;
export const RESEND_INVITE = `${PREFIX}RESEND_INVITE`;

// get all users
export const USERS_REQUESTED = `${PREFIX}USERS_REQUESTED`;
export const USERS_SUCCEEDED = `${PREFIX}USERS_SUCCEEDED`;
export const USERS_FAILED = `${PREFIX}USERS_FAILED`;

// When adding user from modal
export const ADD_USERS_REQUESTED = `${PREFIX}ADD_USERS_REQUESTED`;
export const ADD_USERS_SUCCEEDED = `${PREFIX}ADD_USERS_SUCCEEDED`;
export const ADD_USERS_FAILED = `${PREFIX}ADD_USERS_FAILED`;

// When adding user from modal
export const REMOVE_USER_REQUESTED = `${PREFIX}REMOVE_USER_REQUESTED`;
export const REMOVE_USER_SUCCEEDED = `${PREFIX}REMOVE_USER_SUCCEEDED`;
export const REMOVE_USER_FAILED = `${PREFIX}REMOVE_USER_FAILED`;

export const DELETE_ADMINS_REQUESTED = `${PREFIX}DELETE_ADMINS_REQUESTED`;
export const DELETE_ADMINS_SUCCEEDED = `${PREFIX}DELETE_ADMINS_SUCCEEDED`;
export const DELETE_ADMINS_FAILED = `${PREFIX}DELETE_ADMINS_FAILED`;

export const ADD_ADMINS_REQUESTED = `${PREFIX}ADD_ADMINS_REQUESTED`;
export const ADD_ADMINS_SUCCEEDED = `${PREFIX}ADD_ADMINS_SUCCEEDED`;
export const ADD_ADMINS_FAILED = `${PREFIX}ADD_ADMINS_FAILED`;

export const CITIZEN_SCIENTIST_REQUESTED = `${PREFIX}CITIZEN_SCIENTIST_REQUESTED`;
export const CITIZEN_SCIENTIST_SUCCEEDED = `${PREFIX}CITIZEN_SCIENTIST_SUCCEEDED`;
export const CITIZEN_SCIENTIST_FAILED = `${PREFIX}CITIZEN_SCIENTIST_FAILED`;

export const ADD_CITIZEN_SCIENTIST_REQUESTED = `${PREFIX}ADD_CITIZEN_SCIENTIST_REQUESTED`;
export const ADD_CITIZEN_SCIENTIST_SUCCEEDED = `${PREFIX}ADD_CITIZEN_SCIENTIST_SUCCEEDED`;
export const ADD_CITIZEN_SCIENTIST_FAILED = `${PREFIX}ADD_CITIZEN_SCIENTIST_FAILED`;

export const DELETE_CITIZEN_SCIENTIST_REQUESTED = `${PREFIX}DELETE_CITIZEN_SCIENTIST_REQUESTED`;
export const DELETE_CITIZEN_SCIENTIST_SUCCEEDED = `${PREFIX}DELETE_CITIZEN_SCIENTIST_SUCCEEDED`;
export const DELETE_CITIZEN_SCIENTIST_FAILED = `${PREFIX}DELETE_CITIZEN_SCIENTIST_FAILED`;

export const CHILD_INSPIRE_CAMPUS_PARTNER_REQUESTED = `${PREFIX}CHILD_INSPIRE_CAMPUS_PARTNER_REQUESTED`;
export const CHILD_INSIRE_CAMPUS_PARTNER_SUCCEEDED = `${PREFIX}CHILD_INSIRE_CAMPUS_PARTNER_SUCCEEDED`;
export const CHILD_INSPIRE_CAMPUS_PARTNER_FAILED = `${PREFIX}CHILD_INSPIRE_CAMPUS_PARTNER_FAILED`;

export const CHILD_PARTNER_FAILED = `${PREFIX}CHILD_PARTNER_FAILED`;

export const CHILD_INSPIRE_PARTNER_REQUESTED = `${PREFIX}CHILD_INSPIRE_PARTNER_REQUESTED`;
export const CHILD_INSPIRE_PARTNER_SUCCEEDED = `${PREFIX}CHILD_INSPIRE_PARTNER_SUCCEEDED`;
export const CHILD_INSPIRE_PARTNER_FAILED = `${PREFIX}CHILD_INSPIRE_PARTNER_FAILED`;

export const ADD_CHILD_ADMIN_REQUESTED = `${PREFIX}ADD_CHILD_ADMIN_REQUESTED`;
export const ADD_CHILD_ADMIN_SUCCEEDED = `${PREFIX}ADD_CHILD_ADMIN_SUCCEEDED`;
export const ADD_CHILD_ADMIN_FAILED = `${PREFIX}ADD_CHILD_ADMIN_FAILED`;

export const REMOVE_CHILD_ADMIN_REQUESTED = `${PREFIX}REMOVE_CHILD_ADMIN_REQUESTED`;
export const REMOVE_CHILD_ADMIN_SUCCEEDED = `${PREFIX}REMOVE_CHILD_ADMIN_SUCCEEDED`;
export const REMOVE_CHILD_ADMIN_FAILED = `${PREFIX}REMOVE_CHILD_ADMIN_FAILED`;

export const DELETE_INVITE_REQUESTED = `${PREFIX}DELETE_INVITE_REQUESTED`;
export const DELETE_INVITE_SUCCEEDED = `${PREFIX}DELETE_INVITE_SUCCEEDED`;
export const DELETE_INVITE_FAILED = `${PREFIX}DELETE_INVITE_FAILED`;

export const CREATE_PARTNER_REQUESTED = `${PREFIX}CREATE_PARTNER_REQUESTED`;
export const CREATE_PARTNER_SUCCEEDED = `${PREFIX}CREATE_PARTNER_SUCCEEDED`;
export const CREATE_PARTNER_FAILED = `${PREFIX}CREATE_PARTNER_FAILED`;

export const CLEAR_ERROR_STATE = `${PREFIX}CLEAR_ERROR_STATE`;

export const ADMIN_USER_VIEW = 'pp_admin_user_view';
export const ADMIN_USER_CREATE = 'pp_admin_user_create';
export const ADMIN_USER_DELETE = 'pp_admin_user_delete';

export const CITIZEN_SCIENTIST_VIEW = 'pp_citizen_scientist_view';
export const CITIZEN_SCIENTIST_CREATE = 'pp_citizen_scientist_create';
export const CITIZEN_SCIENTIST_DELETE = 'pp_citizen_scientist_delete';

export const INSPIRE_PARTNER_VIEW = 'pp_inspire_partner_view';
export const INSPIRE_PARTNER_CREATE = 'pp_inspire_partner_create';
export const INSPIRE_PARTNER_DELETE = 'pp_inspire_partner_delete';

export const INSPIRE_CAMPUS_PARTNER_VIEW = 'pp_inspire_campus_partner_view';
export const INSPIRE_CAMPUS_PARTNER_CREATE = 'pp_inspire_campus_partner_create';
export const INSPIRE_CAMPUS_PARTNER_DELETE = 'pp_inspire_campus_partner_delete';

export const INSPIRE = 'inspire';
export const CAMPUS = 'inspire_campus';

export const ADMIN_TAB_VIEW_PERMISSIONS = [
    CITIZEN_SCIENTIST_VIEW,
    CITIZEN_SCIENTIST_CREATE,
    CITIZEN_SCIENTIST_DELETE,
    INSPIRE_PARTNER_VIEW,
    INSPIRE_PARTNER_CREATE,
    INSPIRE_PARTNER_DELETE,
    INSPIRE_CAMPUS_PARTNER_VIEW,
    INSPIRE_CAMPUS_PARTNER_CREATE,
    INSPIRE_CAMPUS_PARTNER_DELETE,
];
